export const SUBMIT_ERROR_TEXT = 'Что-то пошло не так. Попробуйте еще раз';
